import { Component, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgxMatIntlTelInputComponent } from '../ngx-mat-intl-tel-input/ngx-mat-intl-tel-input.component';

@Component({
  selector: 'aura-phone-number-input',
  templateUrl: './phone-number-input.component.html',
  styleUrls: ['./phone-number-input.component.css'],
  imports: [MatFormFieldModule, NgxMatIntlTelInputComponent, ReactiveFormsModule],
})
export class PhoneNumberInputComponent {
  label = input<string>('Numéro de téléphone');
  control = input<FormControl<string | null>>(new FormControl(null));
  required = input<boolean>(false);
  preferredCountries = input<string[]>(['fr']);
  onlyCountries = input<string[]>([]);

  numberChanged = output<string>();

  onModelChanged() {
    const ctrl = this.control();
    if (ctrl?.valid) {
      this.numberChanged.emit(ctrl.value ?? '');
    }
  }
}
